export default {
  fields: {
    discount: {
      label: 'Korting',
    },
    usage_threshold: {
      label: 'Minimumbestelbedrag',
    },
    max_discount: {
      label: 'Maximaal kortingsbedrag',
    },
  },
};
